import { hasDataScope, scopeKey, type DataScope } from "../workflowData/models";
import type { OrganizationChatMessage, OrganizationPreview } from "./models";

export type ScopedOrganizationChatMessage = OrganizationChatMessage & { projectId: string | null; dataScope?: DataScope | null };

/** Project-derived conversation must not be supplied to a different project's run. */
export function visibleOrganizationMessages(messages: readonly ScopedOrganizationChatMessage[], projectId: string | null, dataScope?: DataScope | null): ScopedOrganizationChatMessage[] {
    return messages.filter(message => dataScope ? (!message.dataScope && message.projectId === null) || scopeKey(message.dataScope) === scopeKey(dataScope) : message.projectId === null || message.projectId === projectId);
}

export function currentOrganizationPreview(preview: OrganizationPreview | null, projectId: string | null, requiresProject: boolean, dataScope?: DataScope | null): OrganizationPreview | null {
    if (!preview || (dataScope ? scopeKey(preview.data_scope) !== scopeKey(dataScope) : preview.project_id !== projectId) || (requiresProject && !hasDataScope(dataScope, projectId))) return null;
    return preview;
}
